import { CheckOutlined, CloseOutlined } from "@ant-design/icons"
import { Button, Form, Modal, Radio, Space, Input } from "antd"
import axios from "axios"
import { useEffect, useRef, useState } from "react"

const backend = process.env.REACT_APP_BACKEND;

function SettingModal ({settingModal, stateHandler, gptModel}) {
  const gptRef= useRef()

  const resetHandler = () => {
    gptRef.current.resetFields()
  }

  const changeValue = () => {
    const values = gptRef.current.getFieldsValue()
  
    axios.patch(`${backend}/contents/new_word/image/gpt`,{values})
    .then(res=>{
      stateHandler("settingModal", false)
      stateHandler("gptModel", values)
    })
    .catch(err=>{
      console.log(err)
      Modal.error({
        title: "서버에러",
        content: "서버에서 에러가 발생하여 저장하지 못했습니다.",
        okText: "확인"
      })
    })
  }

  const cancelHandler = () => {
    stateHandler("settingModal", false)
  }

  return (
    <Modal 
      open={settingModal}
      destroyOnClose = {true}
      title = "설정"
      okText = "확인"
      cancelText = "취소"
      onCancel={cancelHandler}
      maskClosable = {false}
      footer = {
        <Space style={{width:"100%", justifyContent:"space-between"}}>
          <Button onClick={resetHandler}>내용 초기화</Button>
          <Space>
            <Button type="primary" onClick={changeValue}><CheckOutlined/>확인</Button>
            <Button onClick={cancelHandler}><CloseOutlined/>취소</Button>
          </Space>
        </Space>
      }
    >
      <Form layout="vertical" ref={gptRef} initialValues={gptModel} >

        <Form.Item
            label = "생성할 이미지 사이즈"
            name = "image_size"
          >
            <Radio.Group>
              <Space>
                <Radio value={"1024x1024"}>1024x1024</Radio>
                <Radio value={"1024x1792"}>1024x1792</Radio>
                <Radio value={"1792x1024"}>1792x1024</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item 
            label = "생성할 이미지 갯수"
            name = "image_count"
          >
            <Input disabled></Input>
          </Form.Item>
          <Form.Item
            label = "프롬프트 생성 엔진"
            name = "gpt_model"
          >
            <Radio.Group>
              <Space>
                <Radio value={"gpt-4"}>GPT 4.0</Radio>
                <Radio value={"gpt-4-1106-preview"}>GPT 4.0 Turbo</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label = "다운사이징 이미지 사이즈"
            name = "image_downsizing_size"
          >
            <Radio.Group>
              <Space>
                <Radio value={"512x512"}>512x512</Radio>
                <Radio value={"512x896"}>512x896</Radio>
                <Radio value={"896x512"}>896x512</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        
      </Form>
    </Modal>
  )
}

export default SettingModal